import React from 'react';
import SmoothImage from '@xFrame4/components/common/SmoothImage';
import { FunctionComponent } from 'react';
import config from '@config';

interface HomeMiniSliderProps
{
    miniSliderThumbnails: MiniSliderThumbnail[];
}

const HomeMiniSlider: FunctionComponent<HomeMiniSliderProps> = (props) =>
{
    /** The slides: desktop. The first slide is not included here (sliced out). */
    let cmpSlidesDesktop = props.miniSliderThumbnails.slice(1).map((miniSliderThumbnail, i) =>
        <div key={i} className="mini-slider-slide mini-slider-slide-desktop col-4 h-100 cursor-pointer">
            <div
                className="mini-slider-slide-desktop-inner h-100"
                onClick={() => window.location.href = config.appUrl + miniSliderThumbnail.url}
            >
                <SmoothImage
                    src={miniSliderThumbnail.image.url}
                    width={miniSliderThumbnail.image.width}
                    height={miniSliderThumbnail.image.height}
                    className="w-100 h-100 base-box"
                    alt={miniSliderThumbnail.name}
                />
                <div className="mini-slider-slider-overlay d-flex flex-column base-box">
                    <div className="flex-grow-1">
                        <span className="mini-slider-slide-text2 text-uppercase bg-primary rounded-1">{miniSliderThumbnail.text2}</span>
                    </div>
                    <div className="mini-slider-slider-overlay-bottom-texts">
                        <div className="mini-slider-slide-name text-uppercase">{miniSliderThumbnail.name}</div>
                        <div className="mini-slider-slide-text1">{miniSliderThumbnail.text1}</div>
                    </div>
                </div>
            </div>
        </div>
    );

    /** The slides: mobile. The first slide is included here. */
    let cmpSlidesMobile = props.miniSliderThumbnails.map((miniSliderThumbnail, i) =>
        <div
            key={i}
            className="mini-slider-slide mini-slider-slide-mobile bg-white base-box"
            onClick={() => window.location.href = config.appUrl + miniSliderThumbnail.url}
        >
            <SmoothImage
                src={miniSliderThumbnail.image.url}
                width={miniSliderThumbnail.image.width}
                height={miniSliderThumbnail.image.height}
                className="w-100 h-100 base-box"
                alt={miniSliderThumbnail.name}
            />
            <div className="mini-slider-slider-overlay d-flex flex-column base-box pt-3 ps-3">
                <div className="flex-grow-1">
                    <span className="mini-slider-slide-text2 text-uppercase bg-primary rounded-1">{miniSliderThumbnail.text2}</span>
                </div>
                <div className="mini-slider-slider-overlay-bottom-texts">
                    <div className="mini-slider-slide-name text-uppercase">{miniSliderThumbnail.name}</div>
                    <div className="mini-slider-slide-text1">{miniSliderThumbnail.text1}</div>
                </div>
            </div>
        </div>
    );

    /** Render */
    return (
        <div className="mini-slider h-100">
            <div className="d-none d-lg-block h-100">
                <div className="row h-100">
                    {cmpSlidesDesktop}
                </div>
            </div>
            <div className="d-lg-none">
                <div className="mini-slider-track">
                    <div className="mini-slider-track-inner">
                        {cmpSlidesMobile}
                    </div>
                </div>
            </div>
        </div>
    );
}

export type MiniSliderThumbnail = {
    name: string;
    text1: string;
    text2: string;
    url: string;
    image: {
        url: string;
        width: number;
        height: number;
    };
    alterImage?: {
        url: string;
        width: number;
        height: number;
    };
}

export default HomeMiniSlider;